import axios from 'axios';

// Separate API client for User Management backend
// This doesn't use the existing haxios because it's a different backend server
// Use relative URL in production (proxied through Nginx), localhost in development
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_USERS_API_URL) {
    return process.env.REACT_APP_USERS_API_URL;
  }
  // In production, use relative URL (proxied through Nginx)
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    return ''; // Relative URL - will use current domain
  }
  // In development, use localhost
  return 'http://localhost:3001';
};

const API_BASE_URL = getApiBaseUrl();

const usersApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 10000 // 10 second timeout
});

// Request interceptor for logging (optional)
usersApi.interceptors.request.use(
  (config) => {
    const fullUrl = `${config.baseURL}${config.url}`;
    console.log(`[Users API] ${config.method.toUpperCase()} ${fullUrl}`);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
usersApi.interceptors.response.use(
  (response) => {
    // Backend returns { success, data, message }
    return response.data;
  },
  (error) => {
    // Handle network errors (server not running)
    if (error.code === 'ECONNREFUSED' || error.message === 'Network Error') {
      const errorMessage = `Cannot connect to backend server at ${API_BASE_URL}. Make sure the server is running with 'npm run dev' in the server directory.`;
      console.error('[Users API] Connection Error:', errorMessage);
      return Promise.reject(new Error(errorMessage));
    }
    
    // Handle timeout errors
    if (error.code === 'ECONNABORTED') {
      const errorMessage = `Request to ${API_BASE_URL} timed out. The server may be slow or unresponsive.`;
      console.error('[Users API] Timeout Error:', errorMessage);
      return Promise.reject(new Error(errorMessage));
    }
    
    // Handle other errors
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred';
    console.error('[Users API] Error:', errorMessage, error.response?.data);
    return Promise.reject(new Error(errorMessage));
  }
);

// Helper methods for common operations
usersApi.bulkUpdate = async (userIds, updates) => {
  const response = await usersApi.patch('/api/users/bulk', {
    userIds,
    updates
  });
  return response;
};

usersApi.bulkDelete = async (userIds) => {
  const response = await usersApi.delete('/api/users/bulk', {
    data: { userIds }
  });
  return response;
};

export default usersApi;

